import firebase from 'firebase/app';
import db from "@/firebase/init";

export default {
  methods: {
    logInWithProvider(authProvider, dialog) {
      if (arguments.length < 1) {
        return;
      }


      let provider;

      if (authProvider === "facebook") {
        provider = new firebase.auth.FacebookAuthProvider();
        this.showFacebookLoginSpinner = true;
      }
      if (authProvider === "google") {
        provider = new firebase.auth.GoogleAuthProvider();
        this.showGoogleLoginSpinner = true;
      }
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          let user = result.user;
          const token = result.credential.accessToken;
          
          let isNewUser = result.additionalUserInfo.isNewUser;

          if (isNewUser) {
            // Set up database for user
            this.setupNewUserInDatabase(user);
            this.removeDialog(dialog);

          } else {
            // Create database entry if it doesent already exist.
            let userRef = db.collection("users").doc(result.user.uid);
            userRef
              .get()
              .then((doc) => {
                // If the user already has a database entry, just redirect them
                if (doc.exists) {
                  console.log("User exists already");
                  // Populate store with user data from firestore
                  // Redirect here
                  // this.$router.push("/").catch(() => { });
                } else {
                  // Create user record
                  this.setupNewUserInDatabase(result.user);
                  // this.$router.push("/").catch(() => { });
                }

                // Stop spinners
                this.showFacebookLoginSpinner = false;
                this.showGoogleLoginSpinner = false;
                //Set access token in store
                this.$store.dispatch('setAccessToken', token);
              })
              .catch((err) => {
                console.log("Error getting document", err.message);
              });

            this.$store.dispatch('setSnackbar', {
              timeout: 3000,
              text: 'You have logged in. Welcome!'
            });
            this.removeDialog(dialog);
          }
        })
        .catch((error) => {
          // Stop spinners
          this.showFacebookLoginSpinner = false;
          this.showGoogleLoginSpinner = false;
          this.feedback = error.message;
        });
    },
    removeDialog(dialog) {
      if (dialog === 'login') {
        this.showLogInDialog = false;
      }
      if (dialog === 'signup') {
        this.showSignUpDialog = false;
      }
    }
  }
}